'use client'; // 👈 Add this at the very top of this file

import Link from 'next/link';
import { useRouter } from 'next/navigation'; // 👈 Use Next.js navigation

export default function NotFoundPage() {
  const router = useRouter(); // 👈 Initialize the router

  return (
    <div className="min-h-screen bg-[#0A1421] flex items-center justify-center px-6 py-12">
      <div className="text-center space-y-10 max-w-3xl mx-auto">
        <div className="space-y-6">
          <h1 className="text-8xl md:text-9xl lg:text-[12rem] font-bold tracking-tight text-white opacity-90 font-serif">
            404
          </h1>
          <h2 className="text-4xl md:text-5xl font-medium text-[#C5A358] tracking-wide">
            Page Not Found
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto leading-relaxed font-light">
            The page you are looking for doesn't exist or has been moved. 
            At The Vantage Crest, we focus on purposeful navigation — let's guide you back.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center pt-6">
          <Link
            href="/"
            className="inline-flex items-center px-10 py-4 bg-[#C5A358] text-[#0A1421] font-semibold rounded-xl hover:bg-[#D4AF37] transition-all duration-300 transform hover:scale-105 shadow-[0_8px_32px_rgba(197,163,88,0.25)] hover:shadow-[0_12px_48px_rgba(197,163,88,0.35)]"
          >
            Return to Home
          </Link>
          <button
            onClick={() => router.back()} // 👈 Safe client-side navigation
            className="inline-flex items-center px-10 py-4 border border-[#C5A358]/40 text-[#C5A358] font-medium rounded-xl hover:bg-[#C5A358]/10 hover:border-[#C5A358]/60 transition-all duration-300"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
